import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { GlassCard } from './GlassCard';
import { MapPin } from 'lucide-react';
const locations = [{
  name: 'USA',
  x: '18%',
  y: '35%'
}, {
  name: 'Canada',
  x: '20%',
  y: '25%'
}, {
  name: 'United Kingdom',
  x: '46%',
  y: '28%'
}, {
  name: 'Ghana',
  x: '47%',
  y: '58%'
}, {
  name: 'Nigeria',
  x: '49%',
  y: '58%'
}, {
  name: 'Cameroon',
  x: '50%',
  y: '59%'
}, {
  name: 'Sierra Leone',
  x: '44%',
  y: '57%'
}, {
  name: 'Togo',
  x: '48%',
  y: '58%'
}, {
  name: 'Kenya',
  x: '56%',
  y: '62%'
}];
export function GlobalPresence() {
  return <section className="py-24 bg-background-secondary/30 relative overflow-hidden" data-id="element-128">
      <div className="container mx-auto px-6" data-id="element-129">
        <SectionHeading title="Global Presence" subtitle="Empowering cybersecurity professionals across continents with world-class training and local support." data-id="element-130" />

        <div className="relative aspect-[2/1] w-full max-w-5xl mx-auto mt-12" data-id="element-131">
          {/* World Map Placeholder SVG */}
          <svg viewBox="0 0 1000 500" className="w-full h-full opacity-10 fill-white" data-id="element-132">
            <path d="M150,100 Q300,50 500,100 T850,100 T850,400 T500,450 T150,400 Z" opacity="0.1" data-id="element-133" />
            {/* Simple world map path representation */}
            <path d="M250,150 L300,150 L300,200 L250,250 Z M450,120 L550,120 L550,200 L450,250 Z M450,300 L550,300 L550,450 L450,450 Z" data-id="element-134" />
          </svg>

          {/* Animated Connection Lines (Simplified) */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" data-id="element-135">
            <motion.path d="M200,175 Q350,150 480,140" fill="none" stroke="url(#lineGradient)" strokeWidth="1" initial={{
            pathLength: 0,
            opacity: 0
          }} whileInView={{
            pathLength: 1,
            opacity: 0.3
          }} viewport={{
            once: true
          }} transition={{
            duration: 2,
            delay: 0.5
          }} data-id="element-136" />
            <motion.path d="M480,140 Q500,250 500,300" fill="none" stroke="url(#lineGradient)" strokeWidth="1" initial={{
            pathLength: 0,
            opacity: 0
          }} whileInView={{
            pathLength: 1,
            opacity: 0.3
          }} viewport={{
            once: true
          }} transition={{
            duration: 2,
            delay: 1
          }} data-id="element-137" />
            <defs data-id="element-138">
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-139">
                <stop offset="0%" stopColor="#1863DC" stopOpacity="0" data-id="element-140" />
                <stop offset="50%" stopColor="#1863DC" stopOpacity="1" data-id="element-141" />
                <stop offset="100%" stopColor="#38BDF8" stopOpacity="0" data-id="element-142" />
              </linearGradient>
            </defs>
          </svg>

          {/* Location Markers */}
          {locations.map((loc, i) => <motion.div key={loc.name} className="absolute group" style={{
          left: loc.x,
          top: loc.y
        }} initial={{
          scale: 0,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-143">
              <div className="relative" data-id="element-144">
                <div className="w-3 h-3 rounded-full bg-primary-blue shadow-[0_0_15px_rgba(24,99,220,0.8)] animate-pulse" data-id="element-145" />
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-20" data-id="element-146">
                  <GlassCard className="px-3 py-1 border-white/20 bg-primary-navy/90" data-id="element-147">
                    <span className="text-[10px] font-bold text-white" data-id="element-148">
                      {loc.name}
                    </span>
                  </GlassCard>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-16" data-id="element-149">
          {['USA', 'Canada', 'United Kingdom', 'West Africa', 'East Africa'].map(region => <div key={region} className="flex items-center gap-3 px-6 py-4 rounded-2xl bg-white/5 border border-white/5" data-id="element-150">
              <MapPin size={16} className="text-primary-blue" data-id="element-151" />
              <span className="text-sm font-bold text-white/80" data-id="element-152">{region}</span>
            </div>)}
        </div>
      </div>
    </section>;
}